<template>

    <h3 class="category-filters-heading" v-if="resourceCount > 0">{{ title }}</h3>

    <filter-group-items
        v-for="(item,index) in items"
        :key="'item' + index"
        :item="item"
        :level="1"
        :group_type="props.group.type"
        :parent-enabled="true"
        ref="allFilterGroupItems"
    ></filter-group-items>


</template>

<script setup>

import { computed, ref } from "vue";

//COMPONENTS
import FilterGroupItems from "./FilterGroupItems";

//PROPS
const props             = defineProps( [ "group" ] );
let allFilterGroupItems = ref( [] );

defineExpose( { collapseAll, expandAll, clearFilters } );

//DATA
let title = props.group.title;
let items = props.group.items;
let type  = props.group.type;

let resourceCount = computed( () => allFilterGroupItems.value.reduce( ( a, filter ) => a + filter.resourceCount, 0 ) )

//METHODS
function collapseAll ()
{
    allFilterGroupItems.value.forEach( item => item.collapse() )
}

function expandAll ()
{
    allFilterGroupItems.value.forEach( item => item.expand() )
}

function clearFilters ()
{

    allFilterGroupItems.value.forEach( item => item.clear() )
}

</script>

<style scoped>

</style>
